// extracted by mini-css-extract-plugin
export default {"shimmer":"shimmer_shimmer__O86uT","shimmer-animation":"shimmer_shimmer-animation__aTXEo"};